/**
 * @author shaojingchao
 * @date 2018/12/11
 * @project kaoshizhongxin
 */
import $ from 'jquery'
// import Vue from 'vue'
// const regTag = /^<([a-z]+)([^<]+)*(?:>(.*)<\/\1>|\s+\/>)$/g

export const processQuesHtml = (v) => {
  let $html = $(`<div>${v}</div>`)
  $html.find('img').removeAttr('width').removeAttr('height')
  // v.replace(/^<([img])([^<]+)*(width|height)=("(\d+)"|'(\d+)'|(\d+))/g)
  return $html.html()
}

export const getHtmlText = (v) => {
  let $html = $(`<div>${v}</div>`).text()
  console.log($html)
  return $html.replace(/^(s*\d+．)/g, '')
}
